import { OrgStructureDetailModel } from "@teamprevent/common/orgStructure/models";

import * as actions from "./actiontypes";
import { OrgStructureAction } from "./actions";

export function orgStructureReducer(
    state: OrgStructureDetailModel = { id: "-1", name: "default", level: 0, customerId: "-1"  },
    action: OrgStructureAction
): OrgStructureDetailModel {
    switch (action.type) {
        case actions.SET_CURRENT_ORGSTRUCTURE:
            return action.payload;
        default:
            return state;
    }
}

export function orgStructures(state: OrgStructureDetailModel[] = [], action: OrgStructureAction): OrgStructureDetailModel[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SUCCESS:
            const newOrgStructures = action.payload.filter(orgLevel => !state.find(l => l.id === orgLevel.id));
            return [...state, ...newOrgStructures].map(org => ({ ...org }));
        case actions.SAVE_ORGSTRUCTURE_SUCCESS:
        case actions.LOAD_ORGSTRUCTURE_DETAIL_SUCCESS:
            return state.map(c => orgStructure(c, action));
        case actions.CREATE_ORGSTRUCTURE_SUCCESS:
            return [...state, action.payload];
        case actions.DELETE_ORGSTRUCTURE_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        case actions.CLEAR_ORGSTRUCTURES:
            return [];
        default:
            return state;
    }
}

function orgStructure(state: OrgStructureDetailModel, action: OrgStructureAction): OrgStructureDetailModel {
    switch (action.type) {
        case actions.SAVE_ORGSTRUCTURE_SUCCESS:
            if (action.payload.id === state.id) {
                return { ...state, ...action.payload };
            }
            return state;
        default:
            return state;
    }
}
